var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"window-area",class:{ 'window-area--resized': _vm.isResized, 'window-area--full-size': !_vm.$store.state.showFolderTitle },style:(_vm.contentStyle),attrs:{"role":"main"}},[_c('nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }